import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { formatTime } from '../utils/timeUtils';

const GameHeader = styled.div`
  opacity: ${props => props.isOverlay ? '0' : '1'};
  ${props => props.isOverlay && 'transition: opacity 0.3s ease;'};
  pointer-events: ${props => props.isOverlay ? 'none' : 'auto'};
  text-align: center;
  margin-bottom: 20px;
  color: white;

  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`;

const GameTitle = styled.h1`
  font-size: 2.5rem;
  margin: 0 0 10px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    display: none;
  }
`;

const GameStats = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    gap: 10px;
    margin-bottom: 15px;
  }
`;

const StatItem = styled.div`
  background: rgba(255, 255, 255, 0.1);
  padding: 10px 20px;
  border-radius: 8px;
  color: white;
  font-weight: bold;
  min-width: 80px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 8px 15px;
    min-width: 60px;
    font-size: 14px;
  }
`;

const Instructions = styled.div`
  background: rgba(255, 255, 255, 0.1);
  padding: 15px;
  border-radius: 8px;
  color: white;
  margin-bottom: 20px;
  text-align: center;
  font-size: 14px;
  max-width: 600px;
`;

const Controls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Button = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  background: ${props => {
    switch (props.variant) {
      case 'primary': return '#4CAF50';
      case 'secondary': return '#f44336';
      case 'tertiary': return '#2196F3';
      default: return '#4CAF50';
    }
  }};
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const OriginalImage = styled.div`
  width: 150px;
  height: 150px;
  background: url(${props => props.imageUrl}) center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 8px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 15px;
`;



const PuzzleHUD = ({ 
  puzzleSize, 
  moves, 
  isComplete, 
  isOverlay,
  onReset,
  hasMovedPuzzle,
  onTimeUpdate,
  gameStage
}) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  // 시간 측정 시작 (밀리초 단위)
  useEffect(() => {
    let interval = null;
    
    if (hasMovedPuzzle && !isComplete) {
      interval = setInterval(() => {
        setElapsedTime(prevTime => prevTime + 10); // 10ms씩 증가
      }, 10); // 10ms마다 업데이트
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [hasMovedPuzzle, isComplete]);

  // 게임 리셋 시 시간 초기화
  useEffect(() => {
    if (!hasMovedPuzzle) {
      setElapsedTime(0);
    }
  }, [hasMovedPuzzle]);

  // 시간 업데이트를 부모 컴포넌트에 전달
  useEffect(() => {
    if (onTimeUpdate) {
      onTimeUpdate(elapsedTime);
    }
  }, [elapsedTime, onTimeUpdate]);


  return (
    <>
      <GameHeader isOverlay={isOverlay}>
        {/* <GameTitle>Image Puzzle</GameTitle> */}
        {/* <Instructions>
          Click on tiles adjacent to the empty space to move them. Reconstruct the original image!
        </Instructions> */}
        <GameStats>
          <StatItem>Stage {gameStage}</StatItem>
          <StatItem>Size {puzzleSize}x{puzzleSize}</StatItem>
          <StatItem>Moves {moves}</StatItem>
          <StatItem>Time {formatTime(elapsedTime)}</StatItem>
        </GameStats>
      </GameHeader>
    </>
  );
};

export default PuzzleHUD; 